// removed by extract-text-webpack-plugin
module.exports = {"container":"container__GUCBf","bodyWrapper":"bodyWrapper__2qG7j","loaderWrapper":"loaderWrapper__15J73","successMessage":"successMessage__1uzZ8","confirmCancellation":"confirmCancellation__3-n9Y","listSubHeading":"listSubHeading__1CrMq","textAreaContainer":"textAreaContainer__1ifio","buttonContainer":"buttonContainer__3ojO-","labelText":"labelText__1WQ01","outerButtonContainer":"outerButtonContainer__39PV3","radioContainer":"radioContainer__58iFW","orText":"orText__3En8Y"};


//////////////////
// WEBPACK FOOTER
// ./components/partial/layers/modals/cancelTransactionModal/style.css
// module id = PQwg
// module chunks = 307